import { yupResolver } from '@hookform/resolvers/yup'
import { Grid, Stack } from '@mui/material'
import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { getAuthenticationFormValidationSchema } from 'components/status-checks/authentication-form-schema-builders'
import {
  type AuthenticationFormValues,
  getDefaultAuthenticationFormValuesFromIntegration
} from 'components/status-checks/authentication-form-utils'
import { ObservabilityToolAuthentication } from 'components/status-checks/form/authentication/ObservabilityToolAuthentication'
import { useObservabilityToolAuthenticationContext } from 'context/status-checks/ObservabilityToolAuthenticationContext'

import type { TeamExternalIntegration } from 'types/api/status-checks/status-check'

export const EditAuthenticationForm: React.FC<{
  externalIntegration: TeamExternalIntegration
  externalIntegrations: TeamExternalIntegration[]
  handleCancel?: () => void
}> = ({ externalIntegration, externalIntegrations, handleCancel }) => {
  const { isDrawerFlow } = useObservabilityToolAuthenticationContext()

  const authenticationFormValidationSchema =
    getAuthenticationFormValidationSchema(externalIntegrations)

  const form = useForm<AuthenticationFormValues>({
    mode: 'all',
    defaultValues:
      getDefaultAuthenticationFormValuesFromIntegration(externalIntegration),
    resolver: yupResolver(authenticationFormValidationSchema)
  })

  return (
    <FormProvider {...form}>
      <Grid container {...(isDrawerFlow && { sx: { mr: 6 } })}>
        <Grid item lg={9} xs={12}>
          <Stack spacing={6}>
            <ObservabilityToolAuthentication
              externalIntegrations={externalIntegrations}
              onCancel={handleCancel}
            />
          </Stack>
        </Grid>
      </Grid>
    </FormProvider>
  )
}
